var React = require('react');

function CloseShareMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M111.537 111.764C113.134 110.164 113.134 107.57 111.537 105.97L69.7972 64.133L111.803 22.0297C113.399 20.4297 113.399 17.8357 111.803 16.2358C110.207 14.6359 107.619 14.6359 106.022 16.2358L64.0167 58.3392L20.9776 15.1999C19.3814 13.6 16.7934 13.6 15.1972 15.1999C13.6009 16.7999 13.6009 19.3939 15.1972 20.9938L58.2363 64.133L15.4626 107.006C13.8663 108.606 13.8663 111.2 15.4626 112.8C17.0588 114.4 19.6468 114.4 21.243 112.8L64.0167 69.9269L105.757 111.764C107.353 113.364 109.941 113.364 111.537 111.764Z","fill":"white"}));
}

CloseShareMenu.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = CloseShareMenu;

CloseShareMenu.default = CloseShareMenu;
